module.exports = __webpack_public_path__ + "static/media/quilv.ace5a23b.png";